export function hasUnsavedQuoteChanges({
  isReady = false,
  currentSignature = "",
  lastSavedSignature = "",
} = {}) {
  if (!isReady) {
    return false;
  }

  return String(currentSignature ?? "") !== String(lastSavedSignature ?? "");
}

export function getSummaryPrerequisiteMessage({
  isLocked = false,
  hasSummaryDatesConfigured = false,
  hasUnsavedChanges = false,
  canManageQuote = false,
} = {}) {
  if (isLocked) {
    return "Unlock this accepted quote before recalculating the summary.";
  }

  if (!hasSummaryDatesConfigured) {
    return "Add at least one quote date before calculating the summary.";
  }

  if (hasUnsavedChanges && !canManageQuote) {
    return "Save quote changes with a customer service account before recalculating the summary.";
  }

  return "";
}

export function canRecalculateSummary({
  isBusy = false,
  isLocked = false,
  hasSummaryDatesConfigured = false,
  hasUnsavedChanges = false,
  canManageQuote = false,
} = {}) {
  if (isBusy || isLocked || !hasSummaryDatesConfigured) {
    return false;
  }

  if (hasUnsavedChanges && !canManageQuote) {
    return false;
  }

  return true;
}
